export default "__VITE_ASSET__D7Ka$Bb9__"